export const aboutContent = {
    es: {
        eyebrow: 'POR QUÉ ELEGIRNOS',
        title: 'Un servicio pensado para verlo todo, sin límites.',
        featuredTitle: '+79.000 canales del mundo',
        featuredBody: 'Accede a 79.000 canales de TV y 249.000 películas y series, incluida una amplia selección de canales europeos.',
        tags: ['Deporte en directo', 'Películas y series', 'Canales premium'],
        tiles: [
            { title: 'Garantía de reembolso', body: '¿No estás satisfecho? Reembolso íntegro en 15 días, sin condiciones.' },
            { title: 'Instalación instantánea', body: 'En cualquier dispositivo, con el reproductor IBO Pro activado gratis.' },
            { title: 'Conexión ultrarrápida', body: 'Servidores europeos dedicados: los canales cargan en menos de 0,5 segundos, sin cortes.' },
        ],
    },
};
